import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class QBuiltInspectorConstants {
  //Global
  setupBtnText: string = 'Inspection Setup';
  startBtnText: string = 'Start Inspection';
  startButtonText: string = 'Start';
  optionalString: string = '(Optional)';

  //Landing page
  technicianNameTitle: string = 'Technician Name: ';
  logoutText: string = 'Logout';
  activeInspectionsTitle: string = 'Active Inspections';
  zoneDropdownLabel: string = 'Zone Selection';

  //Inspection Setup
  facilityTitle: string = 'Facility';
  zoneTitle: string = 'Zone';
  serialSearchPlaceholder: string = 'Search by Serial#';

  //Active Inspection
  newTabText: string = 'New Serial#';
  signOffBtnText: string = 'Submit & Sign-Off';
  //table columns
  checklistItemColumn: string = 'Checklist Item';
  defectColumn: string = 'Defect';
  naColumn: string = 'N/A';
  passColumn: string = 'Pass';
  observedDefectTxt: string = 'Add Observed Defect';

  //new Serial Dialog Text - id1
  newSerialDialogTitle: string = 'Initiate New Inspection';
  newSerialInputTitle: string = 'Search by Serial#';
  //attach photos Dialg - id2
  attachPhotosTitle: string = 'Attach Photos';
  attachPhotosMessage: string =
    'Attach optional photos here of captured defect.';
  fileTypeMessage: string = 'Accepted file types: .jpg, .jpeg, .heic, .png';
  limitMessage: string = 'Limit 5 Photos';
  maxMessage: string = 'Max file size: 5MB';
  addNewPhoto: string = 'Add New Photo';
  uploadPhoto: string = 'Upload from Library';
  endpointUrl: string = 'claytonnex.com/documents/';
  photoErrorMsg: string =
    'Wrong file type, file type too large or you have reached the photo limit of 5 photos';
  previewErrorMsg: string = 'Failed to load photo preview. Please try again.';
  //add Observed Defect Dialog - id3
  odDialogTitle: string = 'Add Observed Defect';
  odDialogMessage: string =
    'Please choose observed defect from list below. If you do not see a defect that covers one that you have found, please reach out to your QBuilt Manager so that they may request a new defect from the home office.';
  odDropdownLabel: string = 'Observed Defect';
  odDropdownPlaceholder: string = 'Type Defect Name';
  //Final Sign Off Dialog - id4
  finalSignOffTitle: string = 'Complete Inspection';
  finalSignOffMessage: string =
    'By e-signing below you agree that this inspection is complete and compliant.';
  finalSignOffPlaceholder: string = 'Generate E-Signature';

  //Buttons
  cancelButtonText: string = 'Cancel';
  startmButtonText: string = 'Start';
  confirmButtonText: string = 'Confirm';
  saveButtonText: string = 'Save';
  saveProgressText: string = 'Save Progress';

  //NA Selection
  naCommentLabel: string = 'N/A Details:';
  naDNItext: string = 'Did not inspect:';

  //Station Designation
  toggleLabel: string = 'Designate to different station?';
  stationDropdownLabel: string = 'Station:';
  stationDropdownPlaceholder: string = 'Select Station...';
  designateBtnText: string = 'Send to Station:';
  sendText: string = 'Send';
  sentToStationText: string = 'Sent to Station: ';
  SentText: string = 'Sent to Station';
  SendToStationText: string = 'Send to Station';
  designateTitle: string = 'Designate to Another Station';

  //Defect Selection
  departmentLabel: string = 'Department:';
  locationLabel: string = 'Location:';
  locationPlaceholder: string = 'Select Location...';
  defectQuantityLabel: string = 'Defect Quantity:';
  defectQuantityPlaceholder: string = 'Select Quantity...';
  defectDescLabel: string = 'Defect Details:';
  attachPhotosLabel: string = 'Attach Photos:';
  addAdditionalDefectText: string = 'Add Additional Defect';
  imageNote: string =
    'Attached images will not appear in the designated station';

  //task group types
  comment: string = 'Comment';
  didNotInspect: string = 'DidNotInspect';
  designateToggle: string = 'StationDeferralSelection';

  //Open Defect Table
  openDefectColumn: string = 'Open Defects';
  designateColumn: string = 'Designate';
  fixedColumn: string = 'Fixed';

  //save progress - navbar specific message
  saveProgressMessage: string =
    'One or more of your inspections may be ready to Submit and Sign-Off, or you may have unsaved changes. Leaving this page may lose these changes. Do you want to proceed?';

  //tooltips
  locationIdTooltip: string =
    'One or more of your defects are missing location information. Please update in order to Save Progress.';
  submitSignOffTooltip: string =
    'One or more of your inspections is ready for Submit & Sign-Off. Please complete these inspections in order to Save Progress.';

  //session storage keys
  defectItemsKey: string = 'cqmsDefectItems';
  cqmsItemsKey: string = 'cqmsSessionItems';
  landingPageItemsKey: string = 'landingPageSessionItems';
}
